import {
  Box,
  Container,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { reportAdsConversion } from "src/libs/analytics";
import { paths } from "src/paths";
import SetupGuide from "./infocards/SetupGuide";
import { verifyPayment } from "./wizard/helpers/paymenthelper";

const PaymentSuccessful: React.FC = () => {
  usePageView();
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [searchParams] = useSearchParams();
  const cname = searchParams.get("cname");
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  useEffect(() => {
    try {
      reportAdsConversion("AW-1026266099/qCllCI7MpO0bEPOnrukD", {
        transaction_id: sessionId || "",
      });
    } catch (error) {
      console.error(error);
    }
  }, [sessionId]);

  useEffect(() => {
    const checkPayment = async () => {
      try {
        if (cname && sessionId) {
          const result = await verifyPayment(cname, sessionId);
          if (result?.error) {
            navigate(paths.paymentFailed, {
              state: { error: result.error.message },
            });
          }
        }
      } catch (error: any) {
        navigate(paths.dashboard.paymentFailed, {
          state: { error: error?.message || "Unknown error" },
        });
      }
    };
    checkPayment();
  }, [cname, sessionId, navigate]);

  return (
    <>
      <Seo title="Building" />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
            pb: "120px",
            height: mdUp ? undefined : "auto",
            flexGrow: 1,
            py: 12,
          }}
        >
          <Container maxWidth="md">
            <Stack
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                pb: 5,
                mx: 2,
              }}
              spacing={2}
            >
              <Typography
                variant="h3"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mt: 2,
                  mb: 2,
                  color: theme.palette.primary.main,
                }}
              >
                {"Building your Nightscout"}
              </Typography>
              <Stack>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {
                    "We've started building your Nightscout. You'll receive an email with a link to access your Nightscout and settings dashboard."
                  }
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {
                    "If you have any questions or need help, please don't hesitate to reach out to us via "
                  }{" "}
                  <Link
                    href="https://wa.me/31639202608"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {"WhatsApp"}
                  </Link>{" "}
                  {"or"}{" "}
                  <Link
                    href="mailto: info@opensource.clinic"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {"Email"}
                  </Link>
                  .
                </Typography>
              </Stack>

              <SetupGuide />
            </Stack>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default PaymentSuccessful;
